import React from "react";

export default function TimeInput({
  label,
  value,
  onChange,
  readOnly = false,
  error,
}) {
  return (
    <div className="form-group">
      <label>{label}:</label>
      <input
        type="time"
        value={value}
        readOnly={readOnly}
        onChange={(e) => onChange && onChange(e.target.value)}
      />
      {error && <p className="error-text">{error}</p>}
    </div>
  );
}
